/** TipTap FontSize mark uses CSS length strings (e.g. pt), aligned with typical rich editors */
const SIZES = [
    { label: '8 pt', value: '8pt' },
    { label: '9 pt', value: '9pt' },
    { label: '10 pt', value: '10pt' },
    { label: '11 pt', value: '11pt' },
    { label: '12 pt', value: '12pt' },
    { label: '14 pt', value: '14pt' },
    { label: '16 pt', value: '16pt' },
    { label: '18 pt', value: '18pt' },
    { label: '20 pt', value: '20pt' },
    { label: '24 pt', value: '24pt' },
    { label: '28 pt', value: '28pt' },
    { label: '36 pt', value: '36pt' },
];

export function buildFontSizeSelectOptions() {
    return [{ label: 'Default', value: '' }, ...SIZES];
}
